import { PEV } from "../../../../common/utils";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { previewGroupMembership } from "./service";
import { defaultPageSize } from "../../../../components/authZTable";

export const PREVIEW_CHANGE = { added: "ADDED", staying: "STAYING", removed: "REMOVED" };
export const defaultTablePageAndSize = { page: 1, size: defaultPageSize };

export const tableIds = {
  addedTable: "addedPreviewTable",
  stayingTable: "stayingPreviewTable",
  removedTable: "removedPreviewTable",
};

const initialState = {
  previewMembership: {
    added: PEV({
      data: [],
      totalPages: 0,
      totalElements: 0,
    }),
    staying: PEV({
      data: [],
      totalPages: 0,
      totalElements: 0,
    }),
    removed: PEV({
      data: [],
      totalPages: 0,
      totalElements: 0,
    }),
    columns: [],
  },
  patchMembershipRequest: {}
};

const getAddedPreviewMembers = createAsyncThunk("previewAddedMembership/fetch", async (param) => {
  return await previewGroupMembership(
    param.userGroupUniqueName,
    param.page,
    param.size,
    PREVIEW_CHANGE.added,
    param.payload
  );
});

const getStayingPreviewMembers = createAsyncThunk(
  "previewStayingMembership/fetch",
  async (param) => {
    return await previewGroupMembership(
      param.userGroupUniqueName,
      param.page,
      param.size,
      PREVIEW_CHANGE.staying,
      param.payload
    );
  }
);

const getRemovedPreviewMembers = createAsyncThunk(
  "previewRemovedMembership/fetch",
  async (param) => {
    return await previewGroupMembership(
      param.userGroupUniqueName,
      param.page,
      param.size,
      PREVIEW_CHANGE.removed,
      param.payload
    );
  }
);

const PreviewMembershipSlice = createSlice({
  name: "previewMembership",
  initialState,
  reducers: {
    setPatchMembershipRequest(state, action) {
      const patchMembershipRequest = action.payload;
      state.patchMembershipRequest = patchMembershipRequest;
    },
  },
  extraReducers: {
    [getAddedPreviewMembers.pending.type]: (state) => {
      state.previewMembership.added = PEV(
        { ...state.previewMembership },
        "Fetching preview membership"
      );
    },
    [getAddedPreviewMembers.fulfilled.type]: (state, action) => {
      state.previewMembership.added = PEV({
        data: action.payload.dataSource,
        totalPages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
      });
      state.previewMembership.columns = action.payload.columns;
    },
    [getAddedPreviewMembers.rejected.type]: (state) => {
      state.previewMembership.added = PEV(
        { ...state.previewMembership },
        null,
        "Error while fetching preview membership"
      );
    },
    [getStayingPreviewMembers.pending.type]: (state) => {
      state.previewMembership.staying = PEV(
        { ...state.previewMembership },
        "Fetching preview membership"
      );
    },
    [getStayingPreviewMembers.fulfilled.type]: (state, action) => {
      state.previewMembership.staying = PEV({
        data: action.payload.dataSource,
        totalPages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
      });
      state.previewMembership.columns = action.payload.columns;
    },
    [getStayingPreviewMembers.rejected.type]: (state) => {
      state.previewMembership.staying = PEV(
        { ...state.previewMembership },
        null,
        "Error while fetching preview membership"
      );
    },
    [getRemovedPreviewMembers.pending.type]: (state) => {
      state.previewMembership.removed = PEV(
        { ...state.previewMembership },
        "Fetching preview membership"
      );
    },
    [getRemovedPreviewMembers.fulfilled.type]: (state, action) => {
      state.previewMembership.removed = PEV({
        data: action.payload.dataSource,
        totalPages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
      });
      state.previewMembership.columns = action.payload.columns;
    },
    [getRemovedPreviewMembers.rejected.type]: (state) => {
      state.previewMembership.removed = PEV(
        { ...state.previewMembership },
        null,
        "Error while fetching preview membership"
      );
    },
  },
});

export const PreviewMembershipReducer = PreviewMembershipSlice.reducer;

const { setPatchMembershipRequest } = PreviewMembershipSlice.actions;

export const PreviewMembershipActions = {
  getAddedPreviewMembers,
  getStayingPreviewMembers,
  getRemovedPreviewMembers,
  setPatchMembershipRequest
};
